export enum CollectNodeFieldTypeEnum {
  CATEGORY = "category",
  TEXT = "text",
  NUMBER = "number",
  PHONE = "phone",
  EMAIL = "email",
  DATE = "date",
  TIME = "time",
  FILE = "file",
  LOCATION = "location",
  SELECT = "select",
}

export enum DateFieldTypeEnum {
  ANY = "any",
  BEFORE_TODAY = "before_today",
  AFTER_TODAY = "after_today",
}

export enum MessageNodeFieldTypeEnum {
  TEXT = "text",
  QUICK_REPLY = "quick_reply",
  MEDIA = "media",
  LINK_BUTTON = "link_button",
  // CAROUSEL = "carousel",
}

export enum NodeTypeEnum {
  START_NODE = "startNode",
  COLLECT_NODE = "collectNode",
  BRANCH_NODE = "branchNode",
  TRIGGER_NODE = "triggerNode",
  MESSAGE_NODE = "messageNode",
  EMAIL_ACTION_NODE = "emailActionNode",
  HTTP_ACTION_NODE = "httpActionNode",
  OPT_IN_ACTION_NODE = "optInActionNode",
  COLLECT_FORM_NODE = "collectFormNode",
}

export enum VariableGroupEnum {
  USER_ATTRIBUTES = "User Attributes",
  COLLECT_NODE_FIELDS = "Collect Node Fields",
  CONVERSATION_ATTRIBUTES = "Conversation Attributes",
  CHANNEL_ATTRIBUTES = "Channel Attributes",
  NUMBER = "Number",
}
